/*
 * Recurring schedule enums.
 *
 * Labels live in features/cmms/cmmsMessages.js with the other enum label helpers so
 * they are translated; the option builders therefore take an `intl` instance.
 */
import { getDayOfWeekLabel, getFrequencyTypeLabel, getTriggerBasisLabel } from "../cmms/cmmsMessages";

export const FrequencyType = {
  Daily: 1,
  Weekly: 2,
  Monthly: 3,
  Yearly: 4,
  EveryNDays: 5,
};

// ScheduleTriggerBasis: what makes the schedule fire.
export const ScheduleTriggerBasis = {
  Calendar: 1,
  RunningTime: 2,
  Quantity: 3,
};

const frequencyTypeValues = [
  FrequencyType.Daily,
  FrequencyType.Weekly,
  FrequencyType.Monthly,
  FrequencyType.Yearly,
  FrequencyType.EveryNDays,
];

const triggerBasisValues = [
  ScheduleTriggerBasis.Calendar,
  ScheduleTriggerBasis.RunningTime,
  ScheduleTriggerBasis.Quantity,
];

// 0 = Sunday, matching the backend's DayOfWeek numbering.
const dayOfWeekValues = [0, 1, 2, 3, 4, 5, 6];

const toOptions = (values, labelFn, intl) =>
  values.map((value) => ({ id: value, value, title: labelFn(value, intl), label: labelFn(value, intl) }));

export const getFrequencyTypeOptions = (intl) => toOptions(frequencyTypeValues, getFrequencyTypeLabel, intl);
export const getTriggerBasisOptions = (intl) => toOptions(triggerBasisValues, getTriggerBasisLabel, intl);
export const getDayOfWeekOptions = (intl) => toOptions(dayOfWeekValues, getDayOfWeekLabel, intl);

export { getDayOfWeekLabel, getFrequencyTypeLabel, getTriggerBasisLabel };
